import { TermsPolicy } from 'pages/public/components/common';
import { FaCheck } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { Button } from 'ui/components/common';
import { cn } from 'utils/helpers';

import PublicWrapper from '../PublicWrapper';

const StartNow = () => {
  const navigate = useNavigate();

  return (
    <PublicWrapper
      className={cn('h-screen', 'flex flex-col items-center justify-center')}
    >
      <div
        className={cn(
          'mt-24 gap-y-7 p-4',
          'flex flex-col items-center',
          'text-center',
        )}
      >
        <div
          className={cn(
            'w-[83px] h-[83px]',
            'flex justify-center items-center',
            'bg-primary-base text-fill-tertiary rounded-full',
          )}
        >
          <FaCheck className="text-[40px]" />
        </div>
        <div>
          <h3 className="text-xl font-semibold">Start with Leapify now!</h3>
          <p className="text-sm">
            Build and manage any customer related work right from Leapify.
          </p>
        </div>
        <Button
          type="button"
          className="font-semibold"
          size="lg"
          label="BACK TO LOGIN"
          onClick={() => navigate('/login')}
        />
      </div>
      <TermsPolicy />
    </PublicWrapper>
  );
};

export default StartNow;
